<div class="service-page">
  <header class="page-hero">
    <h1>Una web profesional que explica bien tu negocio.</h1>
    <p class="hero-lead">
      Diseñamos y desarrollamos páginas web para empresas que necesitan una presencia digital clara,
      actual y preparada para facilitar el contacto.
    </p>
    <a class="button button-primary" routerLink="/contacto">Cuéntanos tu proyecto web</a>
    <p>
      Si buscas un proveedor cercano, consulta nuestro servicio de
      <a routerLink="/desarrollo-web-segovia">diseño y desarrollo web en Segovia</a>.
    </p>
  </header>

  <section class="split-section" aria-labelledby="need-title">
    <div class="section-heading">
      <h2 id="need-title">Tu web debería acompañar al negocio, no quedarse atrás.</h2>
    </div>
    <ul class="check-list">
      <li>Tu empresa todavía no tiene una web propia.</li>
      <li>La web actual ya no representa lo que haces.</li>
      <li>Los servicios resultan difíciles de entender o encontrar.</li>
      <li>El contacto y las llamadas a la acción no están claros.</li>
    </ul>
  </section>

  <section aria-labelledby="scope-title">
    <div class="section-heading">
      <h2 id="scope-title">Una base digital útil y proporcionada.</h2>
      <p>El contenido concreto se define según los objetivos y el alcance acordado.</p>
    </div>
    <div class="feature-grid">
      <article>
        <h3>Estructura y contenido</h3>
        <p>Organización de la información para que cada página tenga una función clara.</p>
      </article>
      <article>
        <h3>Diseño responsive</h3>
        <p>Una experiencia cuidada en móvil, tablet y escritorio.</p>
      </article>
      <article>
        <h3>Desarrollo técnico</h3>
        <p>Implementación accesible, mantenible y orientada al rendimiento.</p>
      </article>
      <article>
        <h3>Preparación para buscadores</h3>
        <p>Jerarquía, contenido y base técnica coherentes con la intención de cada URL.</p>
      </article>
    </div>
  </section>

  <section class="pricing-plans" aria-labelledby="web-price-title">
    <div class="section-heading">
      <h2 id="web-price-title">Elige una base proporcionada para tu web.</h2>
      <p>
        Todos los precios se presentan desde la cantidad indicada y no incluyen IVA. El presupuesto
        final dependerá del alcance concreto, número de páginas, integraciones, contenido y
        complejidad técnica.
      </p>
    </div>

    <div class="pricing-grid">
      <article class="pricing-card">
        <p class="plan-name">Landing esencial</p>
        <h3>Desde 690 € + IVA</h3>
        <p class="plan-fit">
          Para autónomos y pequeños negocios que necesitan una presencia profesional sencilla y
          orientada a captar contactos.
        </p>
        <h4>Lo esencial</h4>
        <ul class="plan-highlights">
          <li>Una página.</li>
          <li>Diseño responsive.</li>
          <li>Formulario de contacto.</li>
        </ul>
        <details class="plan-scope">
          <summary>Ver alcance completo</summary>
          <ul>
            <li>Una página.</li>
            <li>Diseño responsive.</li>
            <li>Presentación del negocio o servicio.</li>
            <li>Llamadas a la acción.</li>
            <li>Formulario de contacto.</li>
            <li>SEO técnico básico.</li>
            <li>Optimización inicial de rendimiento.</li>
            <li>Configuración para publicación.</li>
            <li>Una ronda de cambios.</li>
            <li>Contenido proporcionado por el cliente.</li>
          </ul>
        </details>
        <a class="plan-action" routerLink="/contacto">Consultar esta opción</a>
      </article>

      <article class="pricing-card featured-plan">
        <p class="plan-name">Web profesional · Recomendada</p>
        <h3>Desde 1.290 € + IVA</h3>
        <p class="plan-fit">
          Para empresas que necesitan explicar bien sus servicios y disponer de una web corporativa
          completa.
        </p>
        <h4>Lo esencial</h4>
        <ul class="plan-highlights">
          <li>Web con navegación y varias páginas o secciones.</li>
          <li>Diseño responsive personalizado.</li>
          <li>SEO técnico y estructura de contenidos.</li>
        </ul>
        <details class="plan-scope">
          <summary>Ver alcance completo</summary>
          <ul>
            <li>Web con navegación y varias páginas o secciones.</li>
            <li>Inicio, servicios, información sobre el negocio y contacto.</li>
            <li>Diseño responsive personalizado.</li>
            <li>Formulario de contacto.</li>
            <li>SEO técnico y estructura de contenidos.</li>
            <li>Optimización de imágenes y rendimiento.</li>
            <li>Metadatos, sitemap y robots.</li>
            <li>Dos rondas de cambios.</li>
            <li>Preparación para analítica y publicación.</li>
          </ul>
          <p class="plan-note">
            Puede incorporar reservas u otras integraciones, presupuestadas según su complejidad.
          </p>
        </details>
        <a class="plan-action" routerLink="/contacto">Consultar esta opción</a>
      </article>

      <article class="pricing-card">
        <p class="plan-name">Web avanzada</p>
        <h3>Desde 2.490 € + IVA</h3>
        <p class="plan-fit">
          Para empresas que necesitan contenido dinámico, mayor autonomía o integraciones
          específicas.
        </p>
        <h4>Lo esencial</h4>
        <ul class="plan-highlights">
          <li>Todo lo incluido en la web profesional.</li>
          <li>Gestor de contenidos o CMS y contenido dinámico.</li>
          <li>Integraciones con servicios externos.</li>
        </ul>
        <details class="plan-scope">
          <summary>Ver alcance completo</summary>
          <ul>
            <li>Todo lo incluido en la web profesional.</li>
            <li>Gestor de contenidos o CMS y contenido dinámico.</li>
            <li>Integraciones con servicios externos.</li>
            <li>Formularios o flujos avanzados.</li>
            <li>Automatizaciones.</li>
            <li>Catálogos o estructuras de contenido complejas.</li>
            <li>Backend o funciones cloud.</li>
            <li>Configuración avanzada de analítica.</li>
            <li>Mayor trabajo de arquitectura, testing y despliegue.</li>
          </ul>
        </details>
        <a class="plan-action" routerLink="/contacto">Consultar esta opción</a>
      </article>
    </div>
  </section>

  <section class="faq-section" aria-labelledby="web-faq-title">
    <div class="section-heading">
      <h2 id="web-faq-title">Sobre el desarrollo de una web.</h2>
    </div>
    <div class="faq-list">
      <details>
        <summary>¿Podéis renovar una web existente?</summary>
        <p>
          Sí, una web antigua puede ser el punto de partida. Antes de plantear el trabajo hay que
          revisar su estado, contenidos y objetivos actuales.
        </p>
      </details>
      <details>
        <summary>¿La web se adaptará a móviles?</summary>
        <p>
          El diseño responsive forma parte del planteamiento: la información y las acciones
          principales deben funcionar en distintos tamaños de pantalla.
        </p>
      </details>
      <details>
        <summary>¿Qué necesito preparar para pedir presupuesto?</summary>
        <p>
          Es suficiente con explicar tu negocio, qué quieres conseguir y qué materiales tienes. El
          alcance se puede ordenar después.
        </p>
      </details>
    </div>
  </section>

  <section class="service-cta" aria-labelledby="web-cta-title">
    <h2 id="web-cta-title">Hablemos de la web que necesita tu empresa.</h2>
    <p>Cuéntanos el punto de partida y el objetivo. Te ayudaremos a ordenar la necesidad.</p>
    <a class="button button-primary" routerLink="/contacto">Solicitar una valoración</a>
  </section>
</div>
